import { render, staticRenderFns } from "./Partes.vue?vue&type=template&id=cf8c6c0e&"
import script from "./Partes.vue?vue&type=script&lang=js&"
export * from "./Partes.vue?vue&type=script&lang=js&"
import style0 from "./Partes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports